import { ConfigurationEnvironmentEnum } from "../../../../models";
import { ConfigurationApiDTO } from "../dtos/configuration.dto";

export const mapConfiguration = (configurationDTO: ConfigurationApiDTO["data"]) => {
  const isValidEnvironment = (value: any): value is ConfigurationEnvironmentEnum =>
    value === ConfigurationEnvironmentEnum.DEVELOPMENT ||
    value === ConfigurationEnvironmentEnum.PRODUCTION;

  const environment = isValidEnvironment(configurationDTO.environment)
    ? configurationDTO.environment
    : null;

  return {
    environment,
    firebaseVapidKey: configurationDTO.firebaseVapidKey ?? null,
    modules: {
      icnea: Boolean(configurationDTO.modules?.icnea),
      rentalready: Boolean(configurationDTO.modules?.rentalready),
      hostaway: Boolean(configurationDTO.modules?.hostaway),
    },
  };
};
